<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="table-responsive" v-if="requests.length">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>شناسه درخواست</th>
                            <th>نوع درخواست</th>
                            <th>وضعیت</th>
                            <th>مبلغ</th>
                            <th>ثبت کننده</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(request,index) in requests" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ request.requestId }}</td>
                            <td>{{ request.requestType }}</td>
                            <td>{{ request.flowStepStatusTitle }}</td>
                            <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(request.totalAmount) }} ریال</td>
                            <td>{{ request.customerName }}</td>
                            <td>
                                <router-link :to="{name: 'bankBranches.requests.show',params: {id: request.requestId}}" class="d-inline-block ml-2" title="مشاهده"><i class="ti-eye operationsIcon"></i></router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Requests',
    data(){
        return {
            requests: [],
            showLoading: true,
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Bonus/Requests').then(({data}) => {
                if(data.status){
                    this.requests = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>